import { Injectable } from "@angular/core";
import { ShowCfsTemplateInfo } from "cfs-communication-pack";
import { CommunicationManagerService } from "@app-cfs/shared/services/communication-manager.service";

@Injectable({
  providedIn: 'root'
})
/*** Mock data events for testing ***/
export class MockEventService {

  constructor(private communicationService: CommunicationManagerService) {}

  // Send post message to carousel options:
  // window.postMessage({ type: "suspendCarousel" });
  // window.postMessage({ type: "resetCarousel" });
  // window.postMessage({ type: "resumeCarousel" });

  /*** Uses on POS transactions on the back end side ***/
  showCfsTemplate(): void {
    // to call in FacingScreenBaseComponent onEvents method
    // example: setTimeout(() => this.mockEventService.showCfsTemplate(), 5_000);

    const templateInfo: ShowCfsTemplateInfo = {
      accountTemplateId: 13681,
      timeout: 10
    };

    this.communicationService.sendShowCfsTemplate(templateInfo);

    // to simulate forced template error:
    // in CarouselService displayForcedSlide method modify preparedTemplate
    // for example image template: (preparedTemplate.templateProperties as UrlContentSettings).ImageUrl = (preparedTemplate.templateProperties as UrlContentSettings).ImageUrl + 'cmskcm';
  }
}
